import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const mutationFinancialAccountSyncAtom = createMutationAtomFactory(
  'finance.financialAccountSync',
  (_: void) => ({
    financeFinancialAccountSync: true,
  }),
);
